/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_D$ as D$,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_RespuestaIncidencia as RespuestaIncidencia,
  rec_W$ as W$,
} from "../../runtime/index.jsx";
export function PreguntaIncidencia(e) {
  let t = (0, ReactCompiler.c)(18),
    {
      grupo: n,
      valores: r,
      salteados: i,
      onElegir: a,
      onAlternar: o,
      onSaltear: s,
      sinTitulo: c,
    } = e,
    l = c !== void 0 && c,
    u,
    d,
    f;
  if (
    t[0] !== n.campos ||
    t[1] !== n.nombre ||
    t[2] !== o ||
    t[3] !== a ||
    t[4] !== s ||
    t[5] !== i ||
    t[6] !== l ||
    t[7] !== r
  ) {
    let e = D$(n.campos, r, i);
    ((u = `flex flex-col gap-4 rounded-2xl border border-(--border) bg-(--panel) p-3`),
      t[11] !== n.nombre || t[12] !== l
        ? ((d = !l && (
            <p
              className={`flex items-center gap-2 text-sm font-semibold text-(--text-h)`}
              children={[
                <span
                  className={`text-xl`}
                  aria-hidden={`true`}
                  children={W$(n.nombre)}
                />,
                ` `,
                n.nombre,
              ]}
            />
          )),
          (t[11] = n.nombre),
          (t[12] = l),
          (t[13] = d))
        : (d = t[13]),
      (f = e.map((t, c) => {
        let l =
            r[t.id] == null ||
            r[t.id] === `` ||
            (Array.isArray(r[t.id]) && r[t.id].length === 0),
          u = c === e.length - 1 && l;
        return (
          <div
            key={t.id}
            className={`animar-desde-derecha flex flex-col gap-1`}
            children={[
              <RespuestaIncidencia
                campo={t}
                valor={r[t.id]}
                onElegir={(e) => a(t, e)}
                onAlternar={(e) => o(t, e)}
              />,
              u &&
                !t.obligatorio &&
                !i.has(t.id) &&
                c < n.campos.length - 1 && (
                  <button
                    type={`button`}
                    onClick={() => s(t)}
                    className={`min-h-9 self-start rounded-full px-2 text-xs text-(--text) hover:text-(--accent-texto)`}
                    children={`Saltar esta →`}
                  />
                ),
            ]}
          />
        );
      })),
      (t[0] = n.campos),
      (t[1] = n.nombre),
      (t[2] = o),
      (t[3] = a),
      (t[4] = s),
      (t[5] = i),
      (t[6] = l),
      (t[7] = r),
      (t[8] = u),
      (t[9] = d),
      (t[10] = f));
  } else ((u = t[8]), (d = t[9]), (f = t[10]));
  let p;
  return (
    t[14] !== u || t[15] !== d || t[16] !== f
      ? ((p = <div className={u} children={[d, f]} />),
        (t[14] = u),
        (t[15] = d),
        (t[16] = f),
        (t[17] = p))
      : (p = t[17]),
    p
  );
}
